'use strict';

angular.module('app.userAccountAction', [])
	.controller('userAccountActionCtrl', ['$scope', '$modalInstance', '$modal',
        function ($scope, $modalInstance, $modal){

        $scope.companyCreateModalHandler = function (contactPerson) {
            var createAccountModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/userAndBilling/userAndBillingOverview/createAccount/createAccount.html?app_v=deployDate',
                controller: 'createAccountCtrl'
            });

            $scope.createAccountModalInstance = createAccountModalInstance;
            $scope.contactPerson = contactPerson;
        }; 

        $scope.addToCompanyHandle = function(user_id){
            var modalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/userAndBilling/userManagement/userAccountAction/addUserToAccount/addUserToAccount.html?app_v=deployDate',
                controller: 'addUserToAccountCtrl'
            });
            $scope.modalInstance = modalInstance;
            $scope.user_id = user_id;
        };

        $scope.closeModal = function() {
            $modalInstance.close();
        }
}])